import type { GridColDef } from '@mui/x-data-grid'
import type { AssignmentCreditSource } from './manage.slice'

// WCAG 2.2 Level AA minimum target size (2.5.8 Target Size Minimum)
export let MIN_BUTTON_SIZE = 44

// DataGrid configuration
export let DATAGRID_MIN_HEIGHT = 400
export let DATAGRID_DEFAULT_PAGE_SIZE = 10
export let DATAGRID_PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

export let GROUPS_URLS = {
  INDEX: '/manage/groups',
  CREATE: '/manage/groups/create',
}

export let TRAINING_SERIES_URLS = {
  INDEX: '/manage/training-series',
  CREATE: '/manage/training-series/create',
}

export let ASSIGNMENTS_URLS = {
  INDEX: '/manage/assignments',
  CREATE: '/manage/assignments/create',
}

export let COMPLIANCE_URLS = {
  INDEX: '/manage/compliance',
  CREATE: '/manage/compliance/create',
  TEMPLATES: '/manage/compliance/templates',
  DETAIL: (id: string) => `/manage/compliance/${id}`,
  EDIT: (id: string) => `/manage/compliance/${id}/edit`,
}

export let ASSIGNMENT_ANALYTICS_URLS = {
  INDEX: '/manage/assignments/analytics',
}

export let ROSTER_URLS = {
  INDEX: '/manage/roster',
}

export let courseColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    minWidth: 200,
  },
  {
    field: 'length',
    headerName: 'Length',
    width: 120,
    valueFormatter: (value: number) => `${value.toFixed(1)} hrs`,
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    minWidth: 150,
  },
]

export let userColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    minWidth: 200,
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 2,
    minWidth: 250,
  },
  {
    field: 'group',
    headerName: 'Group',
    flex: 1,
    minWidth: 150,
  },
]

export let CREDIT_SOURCE_CONFIG: Record<
  AssignmentCreditSource,
  { label: string; color: 'info' | 'warning' }
> = {
  ManagerCredit: { label: 'Manager Credit', color: 'info' },
  ThresholdCredit: { label: 'Threshold Credit', color: 'warning' },
}

export let EXTERNAL_CERT_HOUR_TYPES = [
  'Airway Respiratory Ventilation',
  'Medical',
  'Trauma',
  'Operations',
  'Critical Care',
  'OBGYN',
  'Pediatrics Neonatal',
  'Other',
]
